import React from 'react';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
import { cn } from '../../lib/utils';

const TONE_STYLES = {
  warning: {
    wrap: 'border-amber-200/80 bg-[#F8F1E3] text-amber-950',
    Icon: AlertCircle,
  },
  success: {
    wrap: 'border-emerald-200/80 bg-emerald-50 text-emerald-950',
    Icon: CheckCircle2,
  },
};

/** Single-line honesty chip — keep caveats short. */
export function ConfidenceStrip({ tone = 'warning', title, className }) {
  if (!title) return null;
  const config = TONE_STYLES[tone] || TONE_STYLES.warning;
  const Icon = config.Icon;

  return (
    <div
      className={cn(
        'inline-flex max-w-full items-start gap-2 rounded-lg border px-3 py-2 text-xs font-medium leading-snug sm:items-center',
        config.wrap,
        className
      )}
      role="status"
    >
      <Icon className="mt-0.5 h-3.5 w-3.5 shrink-0 sm:mt-0" aria-hidden="true" />
      <span className="min-w-0">{title}</span>
    </div>
  );
}
